const axios = require('axios');
axios.defaults.baseURL = process.env.VUE_APP_NODE_SIDE === 'dev' ? 'http://localhost:3000' : process.env.VUE_APP_REAL_BACK_SERVER_XI;

async function getPlacesSlugs() {
    let result = [];
    await axios.get(`/api/places/slugs`)
        .then((responce) => {
            result = responce.data
        })
        .catch((error) => {
            console.log(error);
        });
    return result
}

const routes = [
    {
      path: '/',
      redirect: '/welcome'
    },
    {
      path: '/welcome',
      name: 'welcome',
      meta: {
        auth: false,
        layout: 'Simple',
        title: 'WildWood — сервис и карта экстремальных тусовок'
      },
      component: () => import('@/views/Welcome' /* webpackChunkName: "welcome" */)
    },
    {
      path: '/auth/yandex',
      name: 'auth-yandex',
      meta: {
        auth: false,
        layout: 'Simple',
        title: 'WildWood — Ya'
      },
      component: () => import('@/views/Auth/Yandex' /* webpackChunkName: "ya" */)
    },
    {
      path: '/events',
      name: 'events',
      meta: {
        auth: false,
        layout: 'Main',
        title: 'WildWood — События',
        description: 'На карте ивентов можно смотреть, кто катается в твоём городе. Отобрать компании по интересам и присоединяться к их событиям. Знакомься с новыми людьми и кто знает, может встретишься с Тони Хоуком! 😎'
      },
      // component: () => import('@/views/Events' /* webpackChunkName: "events" */)
      component: () => import('@/views/Reconstruction' /* webpackChunkName: "events" */)
    },
    {
      path: '/places',
      name: 'places',
      meta: {
        auth: false,
        layout: 'Main',
        title: 'WildWood — Места'
      },
      // component: () => import('@/views/Places' /* webpackChunkName: "places" */)
      component: () => import('@/views/Reconstruction' /* webpackChunkName: "places" */)
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        auth: false,
        layout: 'Empty',
        title: 'WildWood — Вход'
      },
      component: () => import('@/views/Login')
    },
    {
      path: '/registration',
      name: 'registration',
      meta: {
        auth: false,
        layout: 'Empty',
        title: 'WildWood — Регистрация'
      },
      component: () => import('@/views/Registration')
    },
    {
      path: '/shop',
      name: 'shop',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Снаряжение'
      },
      component: () => import('@/views/Shop' /* webpackChunkName: "shop" */)
    },
    {
      path: '/lenta',
      name: 'lenta',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Лента'
      },
      component: () => import('@/views/Lenta' /* webpackChunkName: "lenta" */)
      // component: () => import('@/views/Develop')
    },
    {
      path: '/lenta/:id',
      name: 'pin',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Лента',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Lenta' /* webpackChunkName: "lenta" */)
      // component: () => import('@/views/Forum')
    },
    {
      path: '/settings',
      name: 'settings',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Настройки'
      },
      component: () => import('@/views/Settings' /* webpackChunkName: "settings" */)
    },
    {
      path: '/notifications',
      name: 'notifications',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Уведомления'
      },
      component: () => import('@/views/Notifications' /* webpackChunkName: "notifications" */)
    },
    {
      path: '/events/:hash',
      name: 'event',
      meta: {
        auth: false,
        layout: 'Main',
        title: 'WildWood — События',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Events' /* webpackChunkName: "events" */)
    },
    {
      path: '/messages',
      name: 'messages',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Сообщения'
      },
      component: () => import('@/views/Messages' /* webpackChunkName: "messages" */)
    },
    {
      path: '/messages/:hash',
      name: 'chat',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Сообщения',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Messages' /* webpackChunkName: "messages" */)
    },
    {
      path: '/users',
      name: 'users',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Люди'
      },
      component: () => import('@/views/Users' /* webpackChunkName: "users" */)
    },
    {
      path: '/friends',
      name: 'friends',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Друзья',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Users' /* webpackChunkName: "users" */)
    },
    {
      path: '/offers',
      name: 'offers',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Заявки',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Users' /* webpackChunkName: "users" */)
    },
    {
      path: '/myoffers',
      name: 'myoffers',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Мои заявки',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Users' /* webpackChunkName: "users" */)
    },
    {
      path: '/user/:id',
      name: 'user',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Люди',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Profile' /* webpackChunkName: "profile" */)
    },
    {
      path: '/myprofile',
      name: 'myprofile',
      meta: {
        auth: true,
        layout: 'Main',
        title: 'WildWood — Люди',
        sitemap: { ignoreRoute: true }
      },
      component: () => import('@/views/Profile' /* webpackChunkName: "profile" */)
    },
    {
      path: '/places/:hash',
      name: 'place',
      meta: {
        auth: false,
        layout: 'Main',
        title: 'WildWood — Места',
        description: 'Смотри, где можно покататься в твоём городе: споты, горнолыжные склоны, точки для серфинга и многое другое на карте мест wildwood.',
        sitemap: { 
            slugs: async () => await getPlacesSlugs()
        },
        },
      component: () => import('@/views/Places' /* webpackChunkName: "places" */)
    },
    {
      path: '/activation/:hash',
      name: 'activation',
      component: () => import('@/views/Activation' /* webpackChunkName: "activation" */),
      meta: {
        layout: 'Empty',
        title: 'WildWood — Активация аккаунта',
        sitemap: { ignoreRoute: true }
      }
    },
    {
      path: '/newpass/:hash',
      name: 'newpass',
      component: () => import('@/views/Remind' /* webpackChunkName: "remind" */),
      meta: {
        layout: 'Empty',
        title: 'WildWood — Новый пароль',
        sitemap: { ignoreRoute: true }
      }
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('@/views/Document' /* webpackChunkName: "document" */),
      meta: {
        layout: 'Empty',
        title: 'WildWood — Политика конфиденциальности'
      }
    },
    {
      path: '/agree',
      name: 'agree',
      component: () => import('@/views/Document' /* webpackChunkName: "document" */),
      meta: {
        layout: 'Empty',
        title: 'WildWood — Правила сервиса'
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Admin/Dashboard' /* webpackChunkName: "dashboard" */),
      meta: {
        layout: 'Admin',
        title: 'WildWood — Мониторинг'
      }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/Wrong' /* webpackChunkName: "404" */),
      meta: {
        layout: 'Empty',
        title: 'WildWood — Shit happens',
        sitemap: { ignoreRoute: true }
      }
    }, {
      path: '/ *',
      redirect: '/404'
    }
  ];


  module.exports = routes